import Vue from 'vue' // 引入vue

let requireComponent = require.context(
  './', // 在当前目录下查找
  false, // 不遍历子文件夹
  /\.vue$/ // 正则匹配 以 .vue结尾的文件
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  // 注册组件名称
  Vue.component(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'), componentConfig.default || componentConfig)
})